// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import Debit from '@deere/cps-it.warranty-model-factory/lib/debit';
import {findMatchingKey} from '../../../claim/shared/services/claim-shared-helper';
import {getDefaultState} from '../state';

const getItemIndex = (itemNumber, items) => items.findIndex(item => item.itemNumber === itemNumber);

const updateDebitData = (state, action) =>
    Debit.update(state, {
        $merge: action.debit
    });

const resetPartialDebit = () => getDefaultState().debit;

const updatePartialDebitAdjustmentValue = (state, action) => {

    const itemIndex = getItemIndex(action.itemNumber, state.partialDebit);

    return Debit.update(state, {
        partialDebit: {
            [itemIndex]: {
                valueOfAdjustment: {$set: action.valueOfAdjustment}
            }
        }
    });

};

const updatePartialDebitComments = (state, action) =>
    Debit.update(state, {
        reasonForDebit: {$set: action.comments}
    });

const updateCompanyContribution = (state, action) =>
    Debit.update(state, {
        specialAllowancePartialDebit: {
            changedCompanyContribution: {
                $set: action.value
            }
        }
    });

const updatePartialDebitAdjustmentType = (state, action) => {

    const itemIndex = getItemIndex(action.itemNumber, state.partialDebit);

    return Debit.update(state, {
        partialDebit: {
            [itemIndex]: {
                adjustmentType: {
                    $set: findMatchingKey(action.adjustmentType, action.adjustmentTypes)
                }
            }
        }
    });

};

const updateDebitType = (state, action) =>
    Debit.update(state, {
        debitType: {$set: action.debitType}
    });

export default (state = getDefaultState().debit, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_PARTIAL_DEBIT]: resetPartialDebit,
        [actions.UPDATE_TCSM_PARTIAL_DEBIT_ADJUSTMENT_TYPE]: updatePartialDebitAdjustmentType,
        [actions.UPDATE_TCSM_PARTIAL_DEBIT_ADJUSTMENT_VALUE]: updatePartialDebitAdjustmentValue,
        [actions.UPDATE_TCSM_PARTIAL_DEBIT_COMMENTS]: updatePartialDebitComments,
        [actions.UPDATE_TCSM_PARTIAL_DEBIT_COMPANY_CONTRIBUTION]: updateCompanyContribution,
        [actions.UPDATE_TCSM_PARTIAL_DEBIT_DATA]: updateDebitData,
        [actions.UPDATE_TCSM_PARTIAL_DEBIT_TYPE]: updateDebitType
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/reducers/debit.js